export const initMovieModal = () => {
  const modalButtons = document.querySelectorAll('.movie-modal-btn');
  const allModals = document.querySelectorAll('.movie-modal');

  modalButtons.forEach((btn) => {
    let targetModal = null;

    const targetId = btn.getAttribute('data-target');

    if (targetId) {
      targetModal = document.getElementById(targetId);
    } else if (allModals.length === 1) {
      targetModal = allModals[0];
    } else {
      return;
    }

    const movieInner = targetModal.querySelector('.movieinner');
    const closeBtn = targetModal.querySelector('button.close');

    btn.addEventListener('click', (e) => {
      targetModal.classList.add('-active');
      document.body.style.overflow = 'hidden';
      e.stopPropagation();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        targetModal.classList.remove('-active');
        document.body.style.overflow = 'auto';

        const iframe = targetModal.querySelector('iframe');
        if (iframe) {
          const currentSrc = iframe.src;
          iframe.src = '';
          iframe.src = currentSrc;
        }
        e.stopPropagation();
      });
    }

    targetModal.addEventListener('click', (e) => {
      if (!movieInner.contains(e.target)) {
        targetModal.classList.remove('-active');
        document.body.style.overflow = 'auto';

        const iframe = targetModal.querySelector('iframe');
        if (iframe) {
          const currentSrc = iframe.src;
          iframe.src = '';
          iframe.src = currentSrc;
        }
      }
    });
  });
};
